// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__26A7r","title":"Info_title__34ZdR","selects":"Info_selects__31GRB","requiredAsterisk":"Info_requiredAsterisk__21Uav"};